import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import {
  SolutionCatalogService,
  SolutionNavLink
} from "../../../../core/services/solution-catalog.service";
import { SiilaTranslationService } from "../../../../core/services/siila-translation.service";
import { I18nService } from "../../../services";

@Component({
  selector: "app-solution-list",
  templateUrl: "./solution-list.component.html",
  styleUrls: ["./solution-list.component.scss"]
})
export class SolutionListComponent implements OnInit {
  @Input() val: number = 0;
  /** Same `SolutionCatalogService` list the header and footer render. */
  solutionLinks: SolutionNavLink[] = [];
  currentCode: string;
  isMobile = false;
  arrowLeftAlt: string;
  arrowRightAlt: string;
  constructor(
    private solutionCatalog: SolutionCatalogService,
    private cdr: ChangeDetectorRef,
    public breakpointObserver: BreakpointObserver,
    private i18n: I18nService,
    private siilaTranslationService: SiilaTranslationService
  ) {
    this.currentCode = environment.platformId;
    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }

  ngOnInit(): void {
    this.solutionCatalog.getNavLinks$().subscribe(links => {
      this.solutionLinks = links;
      this.cdr.markForCheck();
    });
    this.arrowLeftAlt = this.siilaTranslationService.getImgSEOTranslation(
      "arrowLeft"
    );
    this.arrowRightAlt = this.siilaTranslationService.getImgSEOTranslation(
      "arrowRight"
    );
  }

  /**
   * Open a solution at its canonical URL for the ACTIVE language.
   *
   * The URL now arrives on the link itself from `SolutionCatalogService`, so
   * this card, the header and the footer are guaranteed to point at the same
   * place. It previously dispatched on id to one of seven methods that each
   * hardcoded an ENGLISH slug, then briefly derived the slug from the CMS
   * `solutionName` — both of which could disagree with what the menu emitted.
   */
  openServe(solution: SolutionNavLink) {
    if (!solution || !solution.path) {
      return;
    }

    window.open(
      `${environment.applicationURL}${solution.path}`,
      this.isMobile || this.val == 1 ? "_self" : "_blank"
    );
  }

  openAllProducts() {
    window.open(
      this.i18n.buildLocalizedPath(`${environment.applicationURL}/products`),
      this.isMobile || this.val == 1 ? "_self" : "_blank"
    );
  }
}
